var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"map-container"},[_c('div',{staticClass:"map"},[_c(_setup.FieldMap,{ref:"map",attrs:{"center":_setup.latLng,"zoom":13,"mini":""}},[_c(_setup.SinglePointPin,{attrs:{"data":_setup.data}})],1)],1)]),_c('vs-text',[_vm._v(_vm._s(_setup.latLng.lat)+", "+_vm._s(_setup.latLng.lng))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }